module.exports = __webpack_public_path__ + "static/img/10.b2519e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carruDepto/10.jpg
// module id = J03Y
// module chunks = 5